/**
 * 全局提示工具 — 基于 antd-mobile Toast（React 18 官方支持）
 *
 * 轻量文字型风格：不使用 icon 大方块，改为在文字前加 emoji 前缀
 */
import { Toast as AntToast } from "antd-mobile";

export interface ToastHandle {
  close: () => void;
}

/** 各类型对应的 emoji 前缀 */
const iconPrefix: Record<string, string> = {
  success: "\u2705 ",   // ✅
  error: "\u274C ",     // ❌
  warning: "\u26A0\uFE0F ", // ⚠️
  info: "\u2139\uFE0F ", // ℹ️
  loading: "\u23F3 ",   // ⏳
};

function show(
  type: "success" | "error" | "warning" | "info" | "loading",
  message: string,
  duration?: number,
): ToastHandle {
  const durationMap: Record<string, number> = {
    success: 2500,
    error: 3000,
    warning: 2800,
    info: 2200,
    loading: 0,
  };

  AntToast.show({
    content: `${iconPrefix[type] || ""}${message}`,
    maskClickable: false,
    duration: duration ?? durationMap[type],
  });

  return { close: () => AntToast.clear() };
}

/** 成功提示 */
export function toastSuccess(message: string): ToastHandle {
  return show("success", message);
}

/** 错误提示 */
export function toastError(message: string): ToastHandle {
  return show("error", message, 3000);
}

/** 警告提示 */
export function toastWarning(message: string): ToastHandle {
  return show("warning", message, 2800);
}

/** 信息提示 */
export function toastInfo(message: string): ToastHandle {
  return show("info", message, 2200);
}

/** 加载提示（需手动 close） */
export function toastLoading(message = "加载中..."): ToastHandle {
  return show("loading", message, 0);
}

export default {
  success: toastSuccess,
  error: toastError,
  warning: toastWarning,
  info: toastInfo,
  loading: toastLoading,
};
